export enum TipoUpload {
  CADASTRO_LOTE_COM_DANFE = 1,
  CADASTRO_LOTE_SEM_DANFE,
  CADASTRO_LOTE_COM_NOTIFIS,
  CADASTRO_LOTE_COM_CTE,
  CADASTRO_LOTE_COM_CTE_NFS,
  CADASTRO_SLA,
}
